export default __webpack_public_path__ + "static/media/short_active.b65a14b4.svg";